export default __webpack_public_path__ + "static/media/CBackground.f8bc58a8.jpg";